export default __webpack_public_path__ + "static/media/twitter.51486491.svg";